import antdRU from "antd/lib/locale-provider/ru_RU";
import ruMessages from "../locales/ru_RU.json";

const RuLang = {
  messages: {
    ...ruMessages,
  },
  antd: antdRU,
  locale: "ru-RU",
};
export default RuLang;
